// extracted by mini-css-extract-plugin
module.exports = {"DataStoreSettingsMaintenance":"DataStoreSettingsMaintenance_AJIAA","DataStoreSettingsMaintenanceDescription":"DataStoreSettingsMaintenanceDescription_59ZK+"};